/**
 * Format bytes as human-readable text.
 *
 * @param bytes Number of bytes.
 * @param si True to use metric (SI) units, aka powers of 1000. False to use
 *           binary (IEC), aka powers of 1024.
 * @param dp Number of decimal places to display.
 *
 * @return Formatted string.
 */
export function humanFileSize(bytes, si=true, dp=1) {
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }

    const units = si
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10**dp;

    do {
        bytes /= thresh;
        ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


    return bytes.toFixed(dp) + ' ' + units[u];
}

/**
 * Translates seconds into human-readable format of seconds, minutes, hours, days, and years
 *
 * @param  {number} seconds The number of seconds to be processed
 * @return {string}         The phrase describing the amount of time
 */
export function secondsToHumanReadable ( seconds ) {
    const minutes = (seconds / 60).toFixed(1);

    const hours = (seconds / (60 * 60)).toFixed(1);

    const days = (seconds / (60 * 60 * 24)).toFixed(1);

    if (seconds < 60) {
        return '~' + Math.round(seconds) + " sec";
    } else if (minutes < 60) {
        return '>' + Math.round(Number(minutes)) + " min";
    } else if (hours < 24) {
        return '>' + Math.round(Number(hours)) + " hrs";
    } else {
        return '>' + Math.round(Number(days)) + " days"
    }
}
